import Axios from './base';

export const CreateWorkorderBuilder = (entity) => Axios().post('Workorder/CreateWorkorders', entity)

export const simulateMyWorkorder = (entity) => Axios().post('Workorder/SimulateWorkorder', entity)
export const UpdateSimulateWorkorder = (id,entity) => Axios().post('Workorder/UpdateSimulateWorkorder/'+id, entity)
export const GetSimulateWorkorder = (id)=> Axios().get('Workorder/GetSimulateWorkorder/'+id)

export const getWorkorderBuilder = () => Axios().get('Workorder/GetWorkorders')

export const UpdateWorkorderBuilder = (id, entity) => Axios('Updated Successfully').put('Workorder/UpdateWorkorders/' + id, entity)

export const getWorkordersById = (id) => Axios(null,"Invalid Id").get('Workorder/getWorkordersById/' + id,)
export const getMyWorkorder = (id) => Axios().get('Workorder/GetMyWorkorders/' + id)
export const getMyWorkorderPaginated = (id, params) => Axios().get('Workorder/GetMyWorkordersPaginated/' + id, { params })
 
